
import { MainLayout } from '@/layout/MainLayout';
import { EngineChart } from '@/features/data-analytics/components/EngineChart';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Activity, Database, TrendingUp, BarChart3 } from 'lucide-react';

const DataAnalytics = () => {
  const analyticsStats = [
    {
      title: '数据采集点',
      value: '1,247',
      change: '+12',
      icon: Database,
      color: 'text-primary'
    },
    {
      title: '实时监控',
      value: '98.7%',
      change: '+0.3%',
      icon: Activity,
      color: 'text-success'
    },
    {
      title: '预测准确率',
      value: '94.2%',
      change: '+1.8%',
      icon: TrendingUp,
      color: 'text-warning'
    },
    {
      title: '处理速度',
      value: '2.3ms',
      change: '-0.1ms',
      icon: BarChart3,
      color: 'text-primary'
    }
  ];

  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">数据分析</h1>
            <p className="text-muted-foreground">船舶运行数据深度分析与智能预测</p>
          </div>
          <Badge className="status-active">
            <Activity className="h-3 w-3 mr-1" />
            实时分析中
          </Badge>
        </div>

        {/* 分析统计 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {analyticsStats.map((stat, index) => (
            <Card key={index} className="tech-card">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-muted-foreground">{stat.title}</p>
                    <p className="text-2xl font-bold text-foreground">{stat.value}</p>
                    <p className={`text-xs mt-1 ${stat.change.startsWith('+') ? 'text-success' : stat.change.startsWith('-') ? 'text-destructive' : 'text-muted-foreground'}`}>
                      {stat.change}
                    </p>
                  </div>
                  <stat.icon className={`h-8 w-8 ${stat.color}`} />
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* 图表区域 */}
        <div className="grid grid-cols-1 gap-6">
          <EngineChart />
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <Card className="tech-card">
              <CardHeader>
                <CardTitle className="flex items-center space-x-2">
                  <TrendingUp className="h-5 w-5 text-primary" />
                  <span>性能趋势分析</span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="flex justify-between items-center p-3 bg-muted/30 rounded-lg">
                    <span className="text-sm">燃油效率</span>
                    <span className="text-sm font-medium text-success">↑ 5.2%</span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-muted/30 rounded-lg">
                    <span className="text-sm">运行稳定性</span>
                    <span className="text-sm font-medium text-success">↑ 2.8%</span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-muted/30 rounded-lg">
                    <span className="text-sm">维护成本</span>
                    <span className="text-sm font-medium text-success">↓ 3.1%</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="tech-card">
              <CardHeader>
                <CardTitle className="flex items-center space-x-2">
                  <BarChart3 className="h-5 w-5 text-primary" />
                  <span>预测模型状态</span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="flex justify-between items-center p-3 bg-muted/30 rounded-lg">
                    <span className="text-sm">温度预测模型</span>
                    <Badge className="status-normal">正常</Badge>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-muted/30 rounded-lg">
                    <span className="text-sm">故障预测模型</span>
                    <Badge className="status-normal">正常</Badge>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-muted/30 rounded-lg">
                    <span className="text-sm">维护预测模型</span>
                    <Badge className="status-warning">调优中</Badge>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default DataAnalytics;
